import { useUserState } from "../store/user-store";
import { UserSettingsApi } from "../api/UserSettingsApi";
import { setupLocale } from "./lang/LanguageService";

const UserService = {
  getUserInfo: async () => {
    const userRes = await UserSettingsApi.userInfo();
    if (!userRes.data) {
      console.error("Failed to get current user");
      return undefined;
    }
    return userRes.data;
  },

  initUser: async () => {
    const user = await UserService.getUserInfo();
    console.log("Current user info loaded!");
    useUserState.getState().setCurrentUser(user);
    await setupLocale(useUserState.getState());
  },
};

export default UserService;
